// extracted by mini-css-extract-plugin
export default {"tabWrapper":"basic-tab__tabWrapper","tabPane":"basic-tab__tabPane"};